import React from 'react';
import { Crown, Check } from 'lucide-react';

const TONES = {
  sage: 'bg-[#8BAA9E] text-[#1C1C1E]',
  gold: 'bg-[#C6A75E] text-[#1C1C1E]',
  muted: 'bg-white/5 text-[#7A7670]',
};

// Photographic Daily Ritual row: image left, numbered title, pill action on the right.
export const RitualCard = ({ index, title, subtitle, image, actionLabel, tone = 'sage', onClick, testId, locked, done }) => (
  <button
    type="button"
    onClick={onClick}
    className={`group w-full flex items-stretch rounded-[18px] overflow-hidden bg-[#2A2A2D] border transition-colors duration-500 text-left ${done ? 'border-[#C6A75E]/30 hover:border-[#C6A75E]/50' : 'border-white/5 hover:border-white/15'}`}
    data-testid={testId}
    data-done={done ? 'true' : 'false'}
  >
    <div className="w-[24%] max-w-[110px] min-h-[88px] shrink-0 relative">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#2A2A2D]/40" />
    </div>
    <div className="flex-1 min-w-0 flex items-center gap-2 pl-3.5 pr-3 py-3">
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-sans text-[#7A7670] tracking-wider">{String(index).padStart(2, '0')}</p>
        <p className="font-serif text-[17px] leading-tight text-[#DCD3CA] line-clamp-2">{title}</p>
        {locked ? (
          <span className="flex items-center gap-1 text-[#C6A75E] text-[11px] font-sans mt-1"><Crown className="w-3 h-3" /> Premium</span>
        ) : (
          <p className="text-[11px] leading-snug font-sans text-[#7A7670] mt-1 line-clamp-2">{subtitle}</p>
        )}
      </div>
      <span className={`shrink-0 flex items-center gap-1 rounded-full px-3.5 py-2 text-[13px] whitespace-nowrap font-sans font-medium transition-transform group-active:scale-95 ${TONES[locked ? 'muted' : tone]}`}>
        {done && <Check className="w-3.5 h-3.5" strokeWidth={2.5} />}
        {actionLabel}
      </span>
    </div>
  </button>
);

export default RitualCard;
